
import React from 'react';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface CoachSpecializationsSectionProps {
  specializations: string[];
  onSpecializationChange: (specialization: string, checked: boolean) => void;
}

const specializationOptions = [
  'Youth Development', 'Strength & Conditioning', 'Mental Performance', 
  'Injury Prevention', 'Game Strategy', 'Player Development'
];

export const CoachSpecializationsSection: React.FC<CoachSpecializationsSectionProps> = ({
  specializations,
  onSpecializationChange
}) => {
  return (
    <Card className="bg-gray-700 border-gray-600">
      <CardHeader>
        <CardTitle className="text-white text-lg">Specializations</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {specializationOptions.map((specialization) => (
            <div key={specialization} className="flex items-center space-x-2">
              <Checkbox
                id={specialization}
                checked={specializations.includes(specialization)}
                onCheckedChange={(checked) => onSpecializationChange(specialization, Boolean(checked))}
              />
              <Label htmlFor={specialization} className="text-gray-300 text-sm cursor-pointer">
                {specialization}
              </Label>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
